import { createFeatureSelector, createSelector } from '@ngrx/store'
import { AnalyticsDataState, MB_ANALYTICS_DATA_FEATURE } from '../state'

export const getMbAnalyticsState = createFeatureSelector<AnalyticsDataState>(MB_ANALYTICS_DATA_FEATURE)

export const getMostRecentAddToCartSource = createSelector(
  getMbAnalyticsState,
  (state: AnalyticsDataState) => state.cart.mostRecentAddToCartSource.id
)

export const getMostRecentAddToEventLabel = createSelector(
  getMbAnalyticsState,
  (state: AnalyticsDataState) => state.cart.mostRecentAddToCartSource.eventLabel
)
